<template>
    <div>
        <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <template v-if="print_toggle">
            <v-card class="box" v-if="ay_forms_data != null">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>View Application Form</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-row justify="center" dense>
                        <v-col sm="2">
                            <v-icon color="error">*</v-icon>
                            <v-select rounded dense required v-model="current_academic_year" :items="ay_list"
                                item-text="ay" item-value="id" label="Academic Year" outlined @change="get_forms" />
                        </v-col>
                        <v-col sm="2">
                            <v-icon color="error">*</v-icon>
                            <v-select rounded dense required v-model="application_status"
                                :items="application_status_list" item-text="name" item-value="id"
                                label="Application Status" outlined @change="get_forms" />
                        </v-col>
                        <v-col sm="2" v-if="application_status">
                            <v-icon color="error">*</v-icon>
                            <v-select rounded dense required v-model="frm" :items="forms_list" item-text="form_no"
                                item-value="id" label="Form Numbers" outlined />
                        </v-col>
                        <!-- <v-col sm="2">
                      <v-icon color="error">*</v-icon>
                      <v-combobox rounded dense required v-model="frm" :items="forms_list" label="Form Numbers" outlined />
                  </v-col> -->
                        <v-col sm="2">
                            <v-btn v-if="tenant == 'uwws' || tenant == 'sbpps'" class="mt-6 button" :disabled="disabled"
                                @click="printForm" :loading="fetch_btn_load">Fetch...</v-btn>
                            <v-btn v-else class="mt-6 button" :disabled="disabled" @click="fetch_form"
                                :loading="fetch_btn_load">Fetch...</v-btn>
                        </v-col>
                        <!-- {{person_details}} -->
                    </v-row>
                </v-card-text>
            </v-card>
        </template>
        <template v-else>
            <div>
                <v-btn class="no-display" @click="print_toggle = true">Close Form</v-btn>
            </div>
            <div id="one_view_form" v-if="person_details != null">
                <!-- <AFUWWS v-if="tenant == 'uwws'" :person_details=person_details></AFUWWS> -->
                <AFWWS v-if="tenant == 'wws'" :person_details=person_details></AFWWS>
                <AFVVP v-else-if="tenant == 'vvp'" :person_details=person_details></AFVVP>
                <AFZEAL v-else-if="tenant == 'zeal'" :person_details=person_details></AFZEAL>
                <AFEPS v-else-if="tenant == 'eps'" :person_details=person_details></AFEPS>
                <AFSBPPS v-else-if="tenant == 'sbpps'" :person_details=person_details></AFSBPPS>
                <AFSANJIVANI v-else-if="tenant == 'sanjivani'" :person_details=person_details></AFSANJIVANI>
                <AFTMV v-else-if="tenant == 'tmvidyalaya'" :person_details=person_details></AFTMV>
                <VDAF v-else :person_details=person_details></VDAF>

            </div>
        </template>
    </div>
</template>
<script>
  import axios from "axios";
  import VDAF from "./ViewDownloadApplicationForm.vue";
  import AFVVP from "./AdmissionFormView/AddmissionFormVvp.vue";
  import AFWWS from "./AdmissionFormView/AddmissionFormWws.vue";
  import AFZEAL from "./AdmissionFormView/AddmissionFormZeal.vue";
  import AFEPS from "./AdmissionFormView/AdmissionFormEPS.vue";
  import AFSBPPS from "./AdmissionFormView/AdmissionFormSbpps.vue";
  import AFSANJIVANI from "./AdmissionFormView/AdmissionFormSanjivani.vue";
  import AFTMV from "./AdmissionFormView/AdmissionFormTMV.vue";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

  export default {
      components: {
          "view-application-form": VDAF,
          VDAF,
          AFVVP,
          AFWWS,
          AFZEAL,
          AFEPS,
          AFSBPPS,
          AFSANJIVANI,
          AFTMV,
              Breadcrumbs,
        
      },
      data: () => ({
          search: "",
          ay_forms_data: null,
          ay_list:null,
          current_academic_year: null,
          fetch_btn_load: false,
          forms_list: null,
          frm: null,
          menu1: false,
          person_details: null,
          extraBreadcrumbItems: [


          ],
          breadcrumbClass: "breadcrumb-style1",
          date: new Date().toISOString().substr(0, 10),
          snackbar_msg: "",
          color: "",
          snackbar: false,
          awspath: null,
          print_toggle: true,
          tenant: true,
          application_status_list:[],
          application_status:null,
      }),
      watch: {
          // current_academic_year() {
          //   this.get_forms();
          // },
          date(val) {
              this.person_details.date_of_birth = this.formatDate(this.date);
          },
      },
      mounted() {
          this.get_ay_forms();
      },
      computed: {
          disabled() {
              return this.forms_list == "No Forms Available";
          },
      },
      created() {
          this.awspath = localStorage.getItem("awspath");
          this.tenant = localStorage.getItem("EPS-tenant");
      },
      methods: {
          get_ay_forms() {
              axios
                  .post("/Admission/get_ay_forms")
                  .then((res) => {
                      if (res.data.msg == "200") {
                          this.ay_forms_data = res.data.data;
                          this.ay_list = res.data.ay_list
                          this.application_status_list = res.data.application_status_list
                         // this.forms_list = res.data.data.forms_list;
                         this.current_academic_year = res.data.data.current_academic_year;
                      } else {
                          //error
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                  });
          },
          get_forms() {
              if (this.current_academic_year != null) {
                  const formData = {
                      ay: this.current_academic_year,
                      application_status:this.application_status
                  };
                  axios
                      .post("/Admission/get_forms", formData)
                      .then((res) => {
                          if (res.data.msg == "200") {
                              console.log(res.data.data);
                              this.forms_list = res.data.forms_list_new;
                              if (this.forms_list.length == 0) {
                                  //console.log(res);

                                  alert("Application forms not found!");
                                  this.person_details = null;
                                  this.forms_list = ["No Forms Available"];
                              } else if (this.forms_list.length != 0) {
                                  //console.log(res);

                                  this.forms_list = res.data.forms_list_new;
                              }
                          }
                      })
                      .catch((error) => {
                          window.console.log(error);
                      })
                      .finally(() => {
                          //close loader
                      });
              }
          },
          fetch_form() {
              //console.log("In fetch_form");
              if (this.frm == null) {
                  this.showSnackbar("#b71c1c", "Please select Form Number!"); // show snackbar
                  this.person_details = null;
              } else {
                  const data = {
                      ay: this.current_academic_year,
                      form_id: this.frm,
                  };
                  localStorage.setItem("admission-ay", this.current_academic_year);
                  axios
                      .post("/Admission/get_application_form", data)
                      .then((res) => {
                          console.log("res", res.data);
                          if (res.data.status.code == "SUCCESS") {
                              this.person_details = res.data.person_details;
                              // (document.getElementById("one_view_form").style.pointerEvents =
                              //   "none"),
                              console.log(this.person_details);
                              this.print_toggle = false;
                          } else {
                              console.log("Nah...");
                              this.person_details = null;
                              //error
                          }
                      })
                      .catch((error) => {
                          window.console.log(error);
                      })
                      .finally(() => {
                          //close loader
                      });
              }
          },
          printForm(){
              if (this.frm == null) {
                  this.showSnackbar("#b71c1c", "Please select Form Number!"); // show snackbar
                  this.person_details = null;
              }
              else{
                localStorage.setItem("setay",  this.current_academic_year);
                localStorage.setItem("setform_id",  this.frm);
                localStorage.setItem("person_details",  this.person_details);
                if(this.tenant == 'uwws'){
                  let routeData = this.$router.resolve({
                          name: "view-application-form-uwws",
                          });
                          window.open(routeData.href, "_blank");
                }
                else if(this.tenant == 'wws'){
                  let routeData = this.$router.resolve({
                          name: "view-application-form-wws",
                          });
                          window.open(routeData.href, "_blank");
                }
                else if(this.tenant == 'vvp'){
                  let routeData = this.$router.resolve({
                          name: "view-application-form-vvp",
                          });
                          window.open(routeData.href, "_blank");
                }
                else if(this.tenant == 'zeal'){
                  let routeData = this.$router.resolve({
                          name: "view-application-form-zeal",
                          });
                          window.open(routeData.href, "_blank");
                }
                else if(this.tenant == 'eps'){
                  let routeData = this.$router.resolve({
                          name: "view-application-form-eps",
                          });
                          window.open(routeData.href, "_blank");
                }
                else if(this.tenant == 'sbpps'){
                  let routeData = this.$router.resolve({
                          name: "view-application-form-sbpps",
                          });
                          window.open(routeData.href, "_blank");
                }
                else if(this.tenant == 'tmvidyalaya'){
                  let routeData = this.$router.resolve({
                          name: "view-application-form-tmv",
                          });
                          window.open(routeData.href, "_blank");
                }
                else{
                  let routeData = this.$router.resolve({
                          name: "view-application-form",
                          });
                          window.open(routeData.href, "_blank");
                }
              }
          },
          formatDate(date) {
              if (!date) return null;
              const [year, month, day] = date.split("-");
              return `${day}/${month}/${year}`;
          },
          parseDate(date) {
              if (!date) return null;
              const [month, day, year] = date.split("/");
              return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
          },
          print() {
              // Get HTML to print from element
              const prtHtml = document.getElementById("one_view_form").innerHTML;

              // Get all stylesheets HTML
              let stylesHtml = "";
              for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                  stylesHtml += node.outerHTML;
              }
              console.log("stylesHtml>>" + stylesHtml);
              // Open the print window
              const WinPrint = window.open("", "", "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0");

              WinPrint.document.write(`<!DOCTYPE html>
                <html>
                <head>
                  ${stylesHtml}
                  
                </head>
                <body>
                  ${prtHtml}
                </body>
                </html>`);

              WinPrint.document.close();
              WinPrint.focus();
              WinPrint.print();
              WinPrint.close();
          },
          print1() {
              window.print();
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
      },
  };
</script>
<style>
.container{
    padding: 0px;
}
@media print {
    .no-display {
        display: none !important;
    }
    .breadcrumb-style1 {
        display: none !important;
        visibility: hidden !important;
    }
}
</style>
